<template>
  <span class="tooltip">
    <span :class="tooltipLabelClasses">
      <slot name="tooltip-label">{{ label }}</slot>
    </span>
    <slot />
  </span>
</template>

<script>
export default {
  name: 'BaseTooltip',
  props: {
    side: {
      type: String,
      default: 'bottom',
      validator(value) {
        return ['top', 'bottom'].indexOf(value) !== -1;
      },
    },
    position: {
      type: String,
      default: 'left',
      validator(value) {
        return ['left', 'right', 'center'].indexOf(value) !== -1;
      },
    },
    label: {
      type: String,
      default: '',
    },
    visible: {
      type: Boolean,
      default: false,
    },
    dark: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    tooltipLabelClasses() {
      return [
        'tooltip-label t4',
        this.side,
        this.position,
        {
          'tooltip-label-visible': this.visible,
          dark: this.dark
        }
      ];
    }
  }
};
</script>

<style lang="scss" scoped>
$information-icon-side: 1.125rem;
$content-fade-duration: 0.3s;
$offset-from-container: 0.25rem;
$tooltip-positioning-offset: 1.5rem;

@mixin positioningClasses($color) {
  &.bottom {
    top: calc((100% + #{$offset-from-container} * 3));

    @include bubble-arrow(top, $color);

    &.left {
      @include bubble-arrow(top, $color, calc((100% - #{$tooltip-positioning-offset} - #{$bubble-arrow-size} * 2)));
    }

    &.right {
      @include bubble-arrow(top, $color, calc(#{$tooltip-positioning-offset} + #{$bubble-arrow-size}));
    }
  }

  &.top {
    bottom: calc((100% + #{$offset-from-container} * 3));
    @include bubble-arrow(bottom, $color, calc(50% - (#{$information-icon-side} / 2)));

    &.left {
      @include bubble-arrow(bottom, $color, calc((100% - #{$tooltip-positioning-offset} - #{$bubble-arrow-size} * 2.5)));
    }

    &.right {
      @include bubble-arrow(bottom, $color, calc(#{$tooltip-positioning-offset} + #{$bubble-arrow-size}));
    }
  }
}

.tooltip {
  display: inline-block;
  position: relative;
  height: $information-icon-side;

  &-label {
    @extend %base-card;
    cursor: text;
    position: absolute;
    padding: 0.5rem;
    box-shadow: $default-shadow-wuk;
    width: max-content;
    max-width: 20rem;
    user-select: none;
    opacity: 0;
    visibility: hidden;
    z-index: 1;
    min-width: 0;

    &-visible {
      opacity: 1;
      visibility: visible;
      transition: visibility 0s, opacity $content-fade-duration linear;
    }

    &.dark {
      background-color: $secondary-color-dark;
      color: $white;
      @include positioningClasses($secondary-color-dark);
    }

    &:not(.dark) {
      @include positioningClasses(white);
    }

    &.center {
      left: 50%;
      transform: translateX(-50%);
    }

    &.right {
      transform: translateX(calc(-#{$tooltip-positioning-offset}));
    }

    &.left {
      transform: translateX(calc(-100% + #{$information-icon-side} + #{$tooltip-positioning-offset}));
    }
  }
}

</style>
